import { queryOptions } from "@tanstack/react-query";
import type { ProductType } from "@/api_server";
import type { Locales } from "@/graphql/generated";
import { getProductEntryContent } from "../../cmsService";
import type { EntryContentByProductType } from "../../contentTypes/entry/generalEntryTypes";

export const entryContentQueryOptions = <P extends ProductType>(
  product: P,
  language: Locales,
) =>
  queryOptions({
    queryKey: ["entry-content", product, language],
    queryFn: (): Promise<EntryContentByProductType<P>> =>
      getProductEntryContent(product, language),
    staleTime: 30 * 60 * 1000,
  });
